import React from "react";
import styled from "@emotion/styled"

const Tags = styled.section`
display: flex;
padding:1rem 0;
flex-wrap: wrap;
line-height: 1.5;
`

export default Tags;